import { computed } from 'vue';
import { createSharedComposable, StorageSerializers, useStorage } from '@vueuse/core';

export const VERSION_SWITCH_DEBUG_STORAGE_KEY = 'novelty-search:version-switch-debug';
export const INVALID_SEARCH_FORCE_ENABLE_STORAGE_KEY = 'invalid-search:force-enable-debug';
export const DEBUG_REGION_STORAGE_KEY = 'debug_region';
export const EOU_ACCESS_DEBUG_STORAGE_KEY = 'eou:force-access-debug';

export type DebugRegion = 'cn' | 'us';

/**
 * 判断当前浏览器是否仍有会改变业务行为的 Debug 覆盖。
 */
export function resolveHasBusinessMock(state: {
    forceEnableNewVersion: boolean;
    forceEnableInvalidSearch: boolean;
    debugRegionOverride: unknown;
    forceEnableEou: boolean;
}): boolean {
    return state.forceEnableNewVersion
        || state.forceEnableInvalidSearch
        || state.forceEnableEou
        || state.debugRegionOverride !== null;
}

// eslint-disable-next-line max-lines-per-function
export const useDebugSettings = createSharedComposable(() => {
    const forceEnableNewVersion = useStorage(
        VERSION_SWITCH_DEBUG_STORAGE_KEY,
        false,
        undefined,
        { writeDefaults: false },
    );
    const forceEnableInvalidSearch = useStorage(
        INVALID_SEARCH_FORCE_ENABLE_STORAGE_KEY,
        false,
        undefined,
        { writeDefaults: false },
    );
    const storedDebugRegionOverride = useStorage<string | null>(
        DEBUG_REGION_STORAGE_KEY,
        null,
        undefined,
        {
            writeDefaults: false,
            serializer: StorageSerializers.string,
        },
    );
    const forceEnableEou = useStorage(
        EOU_ACCESS_DEBUG_STORAGE_KEY,
        false,
        undefined,
        { writeDefaults: false },
    );

    const debugRegionOverride = computed<DebugRegion | null>({
        get() {
            return storedDebugRegionOverride.value === 'cn' || storedDebugRegionOverride.value === 'us'
                ? storedDebugRegionOverride.value
                : null;
        },
        set(value) {
            storedDebugRegionOverride.value = value;
        },
    });
    const hasBusinessMock = computed(() => resolveHasBusinessMock({
        forceEnableNewVersion: forceEnableNewVersion.value,
        forceEnableInvalidSearch: forceEnableInvalidSearch.value,
        debugRegionOverride: storedDebugRegionOverride.value,
        forceEnableEou: forceEnableEou.value,
    }));

    return {
        forceEnableNewVersion,
        forceEnableInvalidSearch,
        debugRegionOverride,
        forceEnableEou,
        hasBusinessMock,
    };
});
